import themeConfig from '@configs/themeConfig'

// APP_LOGO_PATH is a file under public/ ("en/images/logos/nimi_logo.png") or a full URL; it is inlined by next.config
const _logoSrc = (path: string) => (/^(https?:)?\/\//.test(path) || path.startsWith('/') ? path : `/${path}`)

const AppLogo = () => {
  const path = process.env.APP_LOGO_PATH

  if (!path) return null

  return <img src={_logoSrc(path)} alt={themeConfig.templateName} width={120} />
}

export default AppLogo
